import { render, staticRenderFns } from "./QRadio.vue?vue&type=template&id=388358c8&"
import script from "./QRadio.vue?vue&type=script&lang=js&"
export * from "./QRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports